module.exports = __webpack_public_path__ + "img/logo_name.8dfb2356.png";